import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http.service';
import * as moment from 'moment';
import { ChatConfig } from './chat-url.config';

@Injectable({
  providedIn: 'root'
})

export class ChatService {
  constructor(private http: HttpService) {
     // This is intentional
  }

  getUserMessage(messagePayload) {
    return messagePayload.receiver_id && this.http.post(ChatConfig.EndPoint.chat.getUserMessage, messagePayload);
  }

  getChatUsers() {
    return this.http.get(ChatConfig.EndPoint.chat.getChatUsers);
  }

  getCaseList() {
    return this.http.get(ChatConfig.EndPoint.chat.getCaseList);
  }

  getUnreadMessages() {
    return this.http.get(ChatConfig.EndPoint.chat.getUnreadMessages);
  }

  getUserSession(id: any) {
    return this.http.get(ChatConfig.EndPoint.chat.getUserSession.replace('{id}', String(id)));
  }

  getOnlineUsers() {
    return this.http.get(ChatConfig.EndPoint.chat.getOnlineUsers);
  }

  getChatUsersByCase(id: number) {
    return this.http.get(ChatConfig.EndPoint.chat.getChatUsersByCase.replace('{id}', String(id)));
  }

  addChatUsers(payload: any) {
    return this.http.post(ChatConfig.EndPoint.chat.addChatUsers, payload);
  }

  getChildByCase(case_id: number) {
    return this.http.get(ChatConfig.EndPoint.chat.getChildByCase.replace('{case_id}', String(case_id)));
  }

  getSignedDocumentUrl(document) {
    return this.http.post(ChatConfig.EndPoint.document.getSignedDocumentUrl, document);
  }

  addAttachment(payload: any) {
    return this.http.post(ChatConfig.EndPoint.document.addAttachment, payload);
  }

  updateDocumentStatus(payload: any) {
    return this.http.patch(
      ChatConfig.EndPoint.document.updateDocumentStatus.replace('{document_id}', payload.id),
      payload
    );
  }

  getAttachmentById(document_id: string) {
    return this.http.get(ChatConfig.EndPoint.document.getAttachmentById.replace('{document_id}', document_id));
  }

  formatBytes(byte) {
    const units = ['bytes', 'KB', 'MB', 'GB'];
    let index = 0;
    let bytes = parseInt(byte, 10) || 0;

    while (bytes >= 1024 && ++index) {
      bytes = bytes / 1024;
    }

    return bytes.toFixed(bytes < 10 && index > 0 ? 1 : 0) + ' ' + units[index];
  }

  getAbbrevation(name: string) {
    return name
      .split(' ')
      .map(name1 => name1.charAt(0).toLocaleUpperCase())
      .join('');
  }

  getFileExtension(fileType) {
    const FILE_PICTURE_ICON = 'fa fa-file-picture-o';  
    const fileExtension = [
      {
        type: 'text/plain',
        extension: 'TXT',
        icon: 'fa fa-file-text-o'
      },
      {
        type: 'application/pdf',
        extension: 'PDF',
        icon: 'fa fa-file-pdf-o'
      },
      {
        type: 'text/csv',
        extension: 'CSV',
        icon: 'fa fa-file-excel-o'
      },
      {
        type: 'application/json',
        extension: 'JSON',
        icon: 'fa fa-file-text-o'
      },
      {
        type: 'image/png',
        extension: 'PNG',
        icon: FILE_PICTURE_ICON
      },
      {
        type: 'image/jpeg',
        extension: 'JPG',
        icon: FILE_PICTURE_ICON
      },
      {
        type: 'image/jpg',
        extension: 'JPG',
        icon: FILE_PICTURE_ICON
      }
    ];

    return fileExtension.filter(file => file.type === fileType)[0];
  }

  getMessageDate(messageIndex: number, messages: any[]): string {
    const DATE_FORMAT = 'DD MMMM YYYY';
    const dateToday = moment().format(DATE_FORMAT);
    const dateYesterday = moment().subtract(1, 'day').format(DATE_FORMAT);
    const messageDate = moment(messages[messageIndex].createdat).format(DATE_FORMAT);
    if (messageDate === dateToday) {
      return 'Today';
    } else if (messageDate === dateYesterday) {
      return 'Yesterday';
    } else {
      return messageDate;
    }
  }
}
